import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Camera, Video, VolumeX, Volume2, Maximize2, Image as ImageIcon } from 'lucide-react';
import HLSPlayer from '@/components/HLSPlayer';

export const CCTVLiveView = ({ device, onClose }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const streamType = (device?.stream_type || '').toLowerCase();
  const isHlsCompatible = streamType === 'rtsp' || streamType === 'hls' || streamType === 'http';

  return (
    <Dialog open={!!device} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Video className="h-5 w-5" />
            {device?.name}
            <Badge variant={device?.status?.is_online ? "default" : "destructive"}>
              {device?.status?.is_online ? 'Live' : 'Offline'}
            </Badge>
          </DialogTitle>
        </DialogHeader>
        <div className="relative aspect-video bg-black rounded-lg overflow-hidden">
          {isHlsCompatible && device?._id ? (
            <HLSPlayer cameraId={device._id} muted={isMuted} />
          ) : streamType === 'mjpeg' && device?.stream_url ? (
            <img src={device.stream_url} alt="Live Feed" className="w-full h-full object-contain" />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center text-white">
              <div className="text-center">
                <Camera className="h-16 w-16 mx-auto mb-4 opacity-50" />
                <p className="text-lg">Stream Type: {device?.stream_type?.toUpperCase()}</p>
                <p className="text-sm text-gray-400 mt-2">Unsupported in browser</p>
                <Button variant="secondary" className="mt-4" onClick={() => navigator.clipboard.writeText(device?.stream_url || '')}>
                  Copy Stream URL
                </Button>
              </div>
            </div>
          )}
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={() => setIsMuted(!isMuted)}>
              {isMuted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
            </Button>
            <Badge variant="outline">{device?.stream_type?.toUpperCase()}</Badge>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm"><ImageIcon className="h-4 w-4 mr-1" />Snapshot</Button>
            <Button variant="outline" size="sm"><Video className="h-4 w-4 mr-1" />Record</Button>
            <Button variant="outline" size="sm" onClick={() => setIsFullscreen(!isFullscreen)}><Maximize2 className="h-4 w-4" /></Button>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
          <div><p className="text-muted-foreground">IP Address</p><p className="font-medium">{device?.ip_address || 'N/A'}</p></div>
          <div><p className="text-muted-foreground">Location</p><p className="font-medium">{device?.location || 'N/A'}</p></div>
          <div><p className="text-muted-foreground">Signal</p><p className="font-medium">{device?.status?.signal_strength ? `${device.status.signal_strength}%` : 'N/A'}</p></div>
          <div><p className="text-muted-foreground">Last Seen</p><p className="font-medium">{device?.status?.last_seen ? new Date(device.status.last_seen).toLocaleTimeString() : 'N/A'}</p></div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
